export default __webpack_public_path__ + "static/favicon-144x144-aebf6f0ac0a3012a0b3deed4edeb7510.png";